import { render } from "./DetailRecordLayout.vue?vue&type=template&id=df53d7d0"
import script from "./DetailRecordLayout.vue?vue&type=script&lang=js"
export * from "./DetailRecordLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__